<template>
    <div id="app" v-cloak>
        <MainNav/>
        <router-view />
        <MainFooter :class="{'mb-hide block': isMbHide}"/>
        <div id="gotop" class="goTop"
        :class="{'show': isShowTop}" @click="scrollToTop(500)">
            Top
        </div>
        <StatusAlert
        :statusCode="httpStatus.statusCode"
        :triggerOpen="httpStatus.isShow"
        :statusData="httpStatus.statusData" />
        <CommonAlert
        :msg="alertData.msg"
        :triggerOpen="alertData.isShow"
        :callback="alertData.callback" />
        <Loading
        :show="pageData.isLoading" />
    </div>
</template>

<script>
import MainNav from '@/components/_MainNav.vue';
import MainFooter from '@/components/_MainFooter.vue';
import StatusAlert from '@/components/StatusAlert.vue';
import CommonAlert from '@/components/CommonAlert.vue';
import Loading from '@/components/Loading.vue';
import mixinMethod from '@/js/mixin/mixinMethod';

export default {
    name: 'App',
    data() {
        return {
            isShowTop: false,
        };
    },
    computed: {
        isMbHide() {
            return this.$route.name === 'Activity' || this.$route.name === 'ActivityDetail';
        },
    },
    mounted() {
        const vm = this;

        this.setLoading(true);

        window.addEventListener('scroll', () => {
            vm.isShowTop = window.scrollY > 100;
        });

        window.onload = () => {
            this.setLoading(false);
        };
    },
    mixins: [mixinMethod],
    components: {
        MainNav,
        MainFooter,
        StatusAlert,
        CommonAlert,
        Loading,
    },
};
</script>
